"use client";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import { RegistrationProvider } from "@/context/Registration.context";
import { useTheme } from "@/context/Theme.context";
import { Loader } from "@/components/common";
import { Theme } from "@/enums";
import logAnalyticsEvent from "@/utils/logAnalyticsEvent";

const RegistrationStepsGeorgia = dynamic(() =>
  import(
    "@/components/auth/registration/form-components/registration-steps"
  ).then((mod) => mod.RegistrationStepsGeorgia),
);
const RegistrationStepsUkraine = dynamic(() =>
  import(
    "@/components/auth/registration/form-components/registration-steps"
  ).then((mod) => mod.RegistrationStepsUkraine),
);
const RegistrationStepsUzbekistan = dynamic(() =>
  import(
    "@/components/auth/registration/form-components/registration-steps"
  ).then((mod) => mod.RegistrationStepsUzbekistan),
);
const RegistrationFormGeorgia = dynamic(
  () => import("@/components/auth/registration/registration-form-georgia"),
  { ssr: false },
);
const RegistrationFormUkraine = dynamic(
  () => import("@/components/auth/registration/registration-form-ukraine"),
  { ssr: false },
);
const RegistrationFormUzbekistan = dynamic(
  () => import("@/components/auth/registration/registration-form-uzbekistan"),
  { ssr: false },
);

const RegistrationPage = () => {
  const [loading, setLoading] = useState(false);

  const theme = useTheme();

  useEffect(() => {
    if (theme === Theme.GEORGIA) {
      logAnalyticsEvent("start_registration");
    }
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <RegistrationProvider>
      <section className="max-width mt-[108px] grid w-full grid-cols-[309px,auto] gap-[209px]">
        {theme === Theme.GEORGIA && (
          <>
            <RegistrationStepsGeorgia />
            <RegistrationFormGeorgia />
          </>
        )}
        {theme === Theme.UZ && (
          <>
            <RegistrationStepsUzbekistan />
            <RegistrationFormUzbekistan />
          </>
        )}
        {theme === Theme.UK && (
          <>
            <RegistrationStepsUkraine />
            <RegistrationFormUkraine />
          </>
        )}
      </section>
    </RegistrationProvider>
  );
};

export default RegistrationPage;
